export const getMarkedAsHelpful = () => {
    const markedAsHelpful = JSON.parse(localStorage.getItem("markedAsHelpful") || "[]");
    return markedAsHelpful
}

export const isMarkedAsHelpful = (reviewId: string) => {
    return getMarkedAsHelpful().includes(reviewId)
}

export const saveMarkAsHelpful = (reviewId: string) => {
    const markedAsHelpful = getMarkedAsHelpful();
    markedAsHelpful.push(reviewId);
    localStorage.setItem("markedAsHelpful", JSON.stringify(markedAsHelpful));
}
